/* eslint-disable react/react-in-jsx-scope */
import { InputWrapper } from './styles';

export const CodeVerificationInput = props => {
  const { autoFocus, onChange } = props;
  return <InputWrapper autoFocus={autoFocus || false} onChange={onChange} />;
};
